import styles from "./ManifestList.scss";

export const ITEMS_PER_PAGE = 20;
export const TABS_CONFIG = [
  {
    id: "",
    dataTestId: "manifest-list",
    label: "",
    columns: [
      {
        id: "app-id",
        label: "Application Name or Id",
        dataTestId: "app-id-column-header",
        className: styles.appIdColumn,
      },
      {
        id: "manifests-count",
        label: "Manifests",
        dataTestId: "manifests-count-column-header",
        className: styles.countsColumn,
      },
      {
        id: "created_date",
        label: "Creation date",
        sortBy: "created_date",
        dataTestId: "creation-date-column-header",
        className: styles.dateColumn,
      },
      {
        id: "modified_date",
        label: "Last edited",
        sortBy: "modified_date",
        dataTestId: "modified-date-column-header",
        className: styles.dateColumn,
      },
      {
        id: "actions",
        label: "",
        dataTestId: "actions-column-header",
        className: styles.actionMenu,
      },
    ],
  },
];
